<template>
    <x-modal
        :wWidth="1080"
        v-if="visible"
        @cancel="closeModal"
        @close="closeModal"
        @ok="saveHideLeadSourceTypes"
        :draggable="true"
        :resizable="true"
        :loading="loading"
        :okDisabled="loading"
        :okText="'Save'">
        <div slot="title" :class="`d-flex justify-content-between align-items-center`">
            Hide Lead Sources And Types
        </div>

        <div class="user-settings">
            <el-form ref="form">
                <el-row :gutter="10">
                    <el-col>
                        <el-form-item label="Hide Lead Source?" prop="hide_lead_source">
                            <el-select
                                class="w-100"
                                multiple
                                collapse-tags
                                placeholder="Hide Lead Source"
                                @change="handleRemoveFilter"
                                @clear="clearSelectedSources"
                                v-model="selectedSources"
                            >
                                <el-option v-for="item in Ambition.getGlobal('tenant').sources" :key="item.value"
                                           :label="item.label"
                                           :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col>
                        <el-form-item label="Hide Lead Type?" prop="hide_lead_type">
                            <el-select
                                class="w-100"
                                multiple
                                collapse-tags
                                placeholder="Hide Lead Type"
                                @change="handleRemoveFilter"
                                @clear="clearSelectedTypes"
                                v-model="selectedTypes"
                            >
                                <el-option
                                    v-for="item in Ambition.getGlobal('tenant').leadTypes"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
    </x-modal>
</template>

<script>

import {mapGetters, mapState} from "vuex";

export default {
    name: 'HideLeadSourceAndTypes',
    props: {
        sources: {
            type: Array,
            required: false
        },
        leadTypes: {
            type: Array,
            required: false
        },
        visible: {
            required: false
        },
        tenant: {
            required: false
        }
    },
    data() {
        return {
            loading: false,
            selectedSources: [],
            selectedTypes: []
        }
    },
    mounted() {
        this.getHideLeadSourceType()
    },
    computed: {
        ...mapState(["summary", "options"]),
        ...mapGetters({
            assetTypes: 'options/assetTypes',
            leadSources: 'options/sources',
            sourceDetails: 'options/sourceDetails',
            residentialStatusOptions: "options/residentialStatuses",
            user: "user/user",
        }),
        userProfile: {
            get() {
                return this.$store.getters['user/user']
            },
            set(profile) {
                this.$store.dispatch('user/setUser', profile)
            }
        }
    },
    methods: {
        getHideLeadSourceType() {
            axios.get("/admin/account/get-hide-lead-source-type").then((res) => {
                this.selectedTypes = _.get(res.data, 'hideLeadTypes')
                this.selectedSources = _.get(res.data, 'hideLeadSources')
            })
        },
        closeModal() {
            this.$emit('update:visible', false)
        },
        handleRemoveFilter() {
            if (_.size(this.selectedFilterArray) > 0) {
            }
        },
        clearSelectedSources() {
            this.selectedSources = []
        },
        clearSelectedTypes() {
            this.selectedTypes = []
        },
        saveHideLeadSourceTypes() {
            this.loading = true

            let user

            if (this.userProfile.current_team_id) {
                user = Ambition.getGlobal('tenant').tenant.id + '' + this.userProfile.current_team_id
            } else {
                user = Ambition.getGlobal('tenant').tenant.id
            }

            axios
                .post("/admin/account/save-hide-lead-source-type", {
                    id: this.userProfile.id,
                    hideLeadSources: {
                        [user]: this.selectedSources
                    },
                    hideLeadTypes: {
                        [user]: this.selectedTypes
                    }
                })
                .then((response) => {
                    this.getHideLeadSourceType()
                    this.loading = false
                })
                .catch((err) => {
                    this.loading = false
                })
        },
    },
    watch: {}
}
</script>
